import { ExtShecoStreaming } from '@/define/commandSet/etc';
import {
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionGoto,
  ActionReturn,
  ActionStickControl,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
} from '@/define/commandSet/mavlink';

const operation = [
  {
    name: 'Action',
    commands: [ActionArm, ActionDisarm, ActionGoto, ActionStickControl, ActionBrake, ActionReturn],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
  {
    name: 'External',
    commands: [ExtShecoStreaming],
  },
];

export default operation;
